"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesNameToDisplayName = void 0;
exports.languagesNameToDisplayName = {
    java: 'Java',
    dotnet: '.NET',
    python: 'Python',
    php: 'PHP',
    scala: 'Scala',
    go: 'Go',
    ruby: 'Ruby',
    nodejs: 'Node.js',
    ios: 'iOS',
    android: 'Android'
};
